<template>
  <div class="loading" :class="{ 'full-screen': fullScreen }">
    <div class="loading-circle"></div>
    <div class="loading-circle"></div>
  </div>
</template>

<script>
export default {
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.loading {
  display: flex;
  align-items: center;

  &-circle {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background: #FE3355;
    animation: move1 0.8s infinite alternate cubic-bezier(0.4,0,0.2,1);

    &:last-child {
      background: #F09F00;
      animation: move2 0.8s infinite alternate cubic-bezier(0.4,0,0.2,1);
    }
  }

  &.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}


@keyframes move1 {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(10px);
  }
}

@keyframes move2 {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-10px);
  }
}
</style>